const totalPurchasePrice = (price, rewardsDiscount) => price - rewardsDiscount;
const calculateCredits = (purchasePrice, credit) => {
  if (purchasePrice > 0 && purchasePrice <= credit) {
    return purchasePrice;
  } else if (purchasePrice > 0) {
    return credit;
  }
  return 0;
};

export const shineCreditUsed = (price, rewardsDiscount, customerCredits) => {
  const shineCredit = customerCredits.shine;
  const totalPrice = totalPurchasePrice(price, rewardsDiscount);
  return calculateCredits(totalPrice, shineCredit);
};

export const shoppingCreditUsed = (price, rewardsDiscount, customerCredits) => {
  const shoppingCredit = customerCredits.shopping;
  const priceRemaining =
    totalPurchasePrice(price, rewardsDiscount) - shineCreditUsed(price, rewardsDiscount, customerCredits);
  return calculateCredits(priceRemaining, shoppingCredit);
};

export const totalCreditUsed = (price, rewardsDiscount, customerCredits) =>
  shineCreditUsed(price, rewardsDiscount, customerCredits) +
  shoppingCreditUsed(price, rewardsDiscount, customerCredits);
